/** Client-side Free Taste demo samples — no API, no credits, no panel access. */

export type FreeTasteSample = {
  caption: string;
  hashtags: string[];
  visualLabel: string;
  visualHue: number;
};

const CAPTION_POOL: Array<Omit<FreeTasteSample, 'visualHue'>> = [
  {
    caption:
      'Quiet mornings, loud intentions. Building something that feels like you — one post at a time.',
    hashtags: ['brandvoice', 'creators', 'consistency'],
    visualLabel: 'Mood board',
  },
  {
    caption:
      'Behind every clean feed is a messy draft folder. We keep the drafts; you keep the taste.',
    hashtags: ['contentcreation', 'workflow', 'socialmedia'],
    visualLabel: 'Studio light',
  },
  {
    caption:
      'Same niche, different angle. Reference the vibe — never copy the caption.',
    hashtags: ['inspiration', 'aiassist', 'growth'],
    visualLabel: 'City grain',
  },
  {
    caption:
      'Your audience scrolls past noise. Give them one clear sentence and a frame that stops the thumb.',
    hashtags: ['engagement', 'visualstory', 'loopcast'],
    visualLabel: 'Soft gradient',
  },
  {
    caption:
      "Taste is a system: tone, timing, and a little restraint. Here's a sample of that system.",
    hashtags: ['brandtaste', 'scheduling', 'approve'],
    visualLabel: 'Editorial crop',
  },
];

function hashUsername(username: string): number {
  let h = 0;
  for (let i = 0; i < username.length; i++) {
    h = (h * 31 + username.charCodeAt(i)) >>> 0;
  }
  return h;
}

/** Three demo posts shaped by the inspiration handle (deterministic, no network). */
export function freeTasteSamples(rawUsername: string): FreeTasteSample[] {
  const clean = rawUsername.replace(/^@/, '').trim().toLowerCase() || 'inspiration';
  const seed = hashUsername(clean);
  const out: FreeTasteSample[] = [];
  for (let i = 0; i < 3; i++) {
    const item = CAPTION_POOL[(seed + i * 2) % CAPTION_POOL.length];
    out.push({
      ...item,
      caption: `${item.caption}\n\n— inspired by @${clean}`,
      visualHue: (seed + i * 47) % 360,
    });
  }
  return out;
}
